import { Component, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Subject, merge } from 'rxjs';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ItemService } from '../services';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'create-bing-source',
    template: `
        <mat-card [formGroup]="form">
            <mat-card-header>
                <h2>Create Bing Search Source</h2>
            </mat-card-header>
            <mat-card-content style="padding: 25px;">
                <div fxLayout="column" style="height: 100%">
                    <mat-form-field fxFlex>
                        <input matInput placeholder="Title" formControlName="title">
                    </mat-form-field>
                    <mat-form-field fxFlex>
                        <input matInput placeholder="Search Term" formControlName="searchTerm">
                        <mat-error *ngIf="form.get('searchTerm').hasError('required')">Search Term is required.</mat-error>    
                    </mat-form-field>
                    <div>
                        <label id="bing-type-label" style="padding-right: 10px;">Result Type</label>
                        <mat-radio-group aria-labelledby="bing-type-label" formControlName="bingType">
                            <mat-radio-button value="NEWS" style="padding-right: 10px;">News</mat-radio-button>
                            <mat-radio-button value="WEB" style="padding-right: 10px;">Web</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
            </mat-card-content>
            <mat-card-actions>
                <button mat-raised-button [color]="streamConfig ? undefined : 'primary'" [disabled]="form.invalid" (click)="search()">Search</button>
                <button *ngIf="streamConfig" mat-raised-button color="primary" (click)="saveStream()">Save</button>
            </mat-card-actions>
        </mat-card>
    `
})
export class CreateBingSourceComponent implements OnDestroy {
    private cleanupTime = new Subject<void>();
    form: FormGroup;
    streamConfig;
    @Output() resultsFetched = new EventEmitter<any>();
    @Output() matchFound = new EventEmitter<any>();
    @Output() save = new EventEmitter<any>();
    
    constructor(fb: FormBuilder, private snackbar: MatSnackBar, private itemService: ItemService) {
    
        this.form = fb.group({
            title: [],
            searchTerm: [],
            bingType: ['NEWS'],
        });

        merge(...['title', 'searchTerm', 'bingType'].map(key => this.form.get(key).valueChanges))
        .pipe(takeUntil(this.cleanupTime))
        .subscribe(() => {
            this.streamConfig = undefined;
            this.resultsFetched.emit();
        });
    }

    search(): void {
        this.itemService.searchBing(this.form.get('searchTerm').value, { type: this.form.get('bingType').value })
        .subscribe(
            bingItems => {
                if (!this.form.get('title').value) {
                    this.form.get('title').setValue(this.form.get('searchTerm').value, { emitEvent: false });
                }
                this.streamConfig = this.form.value;
                this.resultsFetched.emit({
                    title: this.form.get('title').value,
                    description: this.form.get('searchTerm').value,
                    items: bingItems
                });
            },
            () => this.snackbar.open('Bing search failed', 'OK',  { duration: 5000 })
        );
    }

    saveStream(): void {
        this.save.emit({
            title: this.form.get('title').value,
            type: 'BING_SEARCH',
            description: this.form.get('searchTerm').value,
            openForReading: true,
            emailPostingEnabled: false,
            settings: {
                type: this.form.get('bingType').value,
                search: this.form.get('searchTerm').value
            }
        });
    }

    ngOnDestroy(): void {
        this.cleanupTime.next();
        this.cleanupTime.complete();
    }
}